import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import NavMenu from './components/NavMenu';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
// import Contact from './pages/Contact';
import HeroSection from './components/HeroSection';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <>
      <Router basename="/portfolio">
        <NavMenu />
        <ScrollToTop />
        <HeroSection />
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/projects">
            <Projects />
          </Route>
          {/* <Route path="/contact">
            <Contact />
          </Route> */}
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  );
}
